<template>
  <div class="plugin-wrap video-home" @click="actionHandler(config.action)" v-if="config" :style="{height:swiperHeight && swiperHeight + 'px'}">
    <VideoWrap :vSrc="config.video" :vSrc_m="config.video_h5" :iSrc="config.src" :iSrc_m="config.src_h5" :isAuto="config.isAuto" :isLoop="config.isLoop" :showControls="false" />
  </div>
</template>

<script>
import VideoWrap from '@/components/VideoWrap';
import acitonMixins from "@/utils/action.mixins";
export default {
  name: 'VideoHome',
  mixins: [acitonMixins],
  components: { VideoWrap },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      swiperHeight: null
    }
  },
  created() {
    if(window.innerWidth < 1024){
      this.swiperHeight = window.innerWidth / 750 * 1170
      console.log(this.swiperHeight)
    }
  },
}
</script>

<style lang="scss" scoped>
  .video-home {
    box-sizing: border-box; width: 100vw; height: 100vh; position: relative; overflow: hidden;
  }
</style>